<template>
  <v-card>
    <v-img
      :src="station.image"
      :aspect-ratio="16/9"
    />

    <v-card-title class="title">{{station.name}}</v-card-title>

    <v-card-subtitle class="d-flex flex-row align-center">
      <!-- 都道府県名 -->
      <div>{{station.pref}}</div>

      <v-spacer />

      <!-- 特徴アイコン -->
      <c-features :enables="features" :features="station.features"/>
    </v-card-subtitle>

    <v-card-text class="body-2">
      <!-- 住所 -->
      <c-spec-item icon="map">
        <span class="d-block mb-1">{{station.access}}</span>
        <a class="d-block" :href="station.map" target="_blank">{{station.address}}</a>
      </c-spec-item>

      <!-- 営業時間 -->
      <c-spec-item icon="access_time">
        <span
          v-for="(time, index) in station.workTime"
          :key="index"
          class="d-block"
        >
          {{time.caption}}: {{time.text}}
        </span>
      </c-spec-item>

      <!-- 電話番号 -->
      <c-spec-item icon="phone" v-show="station.phone">
        <a :href="`tel:` + station.phone">{{station.phone}}</a>
      </c-spec-item>

    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <!-- v-btn
        text
        :to="{name: 'book', params: {stid: station.stationID}}"
        v-text="'予約する'"
      / -->
      <v-btn
        class="primary"
        text
        :to="{name: 'cars', params: {stid: station.stationID}}"
        v-text="'車種一覧'"
      />
      <v-btn
        class="primary"
        text
        :to="{name: 'availability', params: {stid: station.stationID}}"
        v-text="'空き状況'"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import CFeatures from './CFeatures'
import CSpecItem from './CSpecItem'

export default {
  name: 'CStationCard',
  components: {
    CFeatures,
    CSpecItem
  },
  props: {
    features: {
      type: Object,
      required: true
    },
    station: {
      type: Object,
      required: true
    }
  }
}
</script>
